import type { TopBarDropdownContextProps } from 'Components/TopBar/contexts/TopBarDropdownContext';
import { DropDownItemTopBar } from 'Components/TopBar/DropDownItemTopBar';
import { ContactModelV2 } from 'Models/ContactModelV2';
import React from 'react';

export type createExtrContactOptionsProps = (
  extrContacts: ContactModelV2[],
  isNumericSearch?: boolean,
  searchQuery?: string
) => TopBarDropdownContextProps['options'];

export const createExtrContactOptions: createExtrContactOptionsProps = (
  extrContacts,
  isNumericSearch,
  searchQuery
) => {
  return (
    extrContacts
      ?.filter(({ phoneNumbers }) => phoneNumbers.length)
      ?.map(({ id, name, phoneNumbers, organization, avatarUrl, role }) => ({
        key: id,
        value: phoneNumbers[0]?.number,
        /**
         * We add the searchQuery to the text prop, so the dropdown displays it
         * TODO: Stop using semantic UI dropdown
         */
        text: isNumericSearch ? searchQuery : name,
        variant: 'external-contact',
        phoneNumber: phoneNumbers[0]?.number,
        label: (
          <DropDownItemTopBar
            key={id}
            userInfo={{
              phoneNumbers: phoneNumbers.map(({ number }) => number),
              keyValue: id,
            }}
            name={name}
            variant="external-contact"
            {...{ organization, pictureUrl: avatarUrl, role }}
          />
        ),
      })) || []
  );
};
